import $api, {API_URL} from "./instance";
import errorMessage from "../const/Tost";

export const laborantService = {
    async getDirection(id){
        try{
            return await $api.get(`${API_URL}/direction/manage/${id}?withAssociates=true`,)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async updateLabForm(id, data){
        try{
            return await $api.put(`${API_URL}/direction/manage/${id}/laboratory-form`, data)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async updateStatusDirection(id, data){
        try{
            return await $api.put(`${API_URL}/direction/manage/${id}`, data)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }
}